module.exports = __webpack_public_path__ + "static/media/ba9c33c1-4dec-4253-8914-9488bd421a51.63f59512.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/ba9c33c1-4dec-4253-8914-9488bd421a51.jpg
// module id = 847
// module chunks = 0